// import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { auth } from '../config/firebase';
// import {  signInWithPhoneNumber } from 'firebase/auth';
// import { Bounce, toast } from 'react-toastify';
// import { Loader2 } from 'lucide-react';
// import { useTranslation } from 'react-i18next';

// const MobileValidation = ({ onValidation, mobile = '' }) => {
//   const [phone, setPhone] = useState(mobile);
//   const [otp, setOtp] = useState('');
//   const [showOTP, setShowOTP] = useState(false);
//   const [confirmationResult, setConfirmationResult] = useState(null);
//   const [error, setError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [timeLeft, setTimeLeft] = useState(0);
//   const [verificationSuccess, setVerificationSuccess] = useState(false);
//   const [retryCount, setRetryCount] = useState(0);
//   // const [recaptchaInitialized, setRecaptchaInitialized] = useState(false);

//   const { t } = useTranslation();
//   const timerRef = useRef(null);
//   const mountedRef = useRef(true);

//   // const setupRecaptcha = useCallback(() => {
//   //   if (window.recaptchaVerifier) return;

//   //   try {
//   //     window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
//   //       size: 'invisible',
//   //       callback: () => {
//   //         console.log('reCAPTCHA solved successfully');
//   //         setError('');
//   //       },
//   //       'expired-callback': () => {
//   //         console.warn('reCAPTCHA expired');
//   //         const msg = t('recaptchaerror') || 'reCAPTCHA expired. Please try again.';
//   //         setError(msg);
//   //         toast.error(msg, { position: 'top-center', autoClose: 3000, theme: 'light', transition: Bounce });
//   //       },
//   //       'error-callback': (err) => {
//   //         console.error('reCAPTCHA error:', err);
//   //         const msg = t('recaptchaerror') || 'reCAPTCHA error. Please try again.';
//   //         setError(msg);
//   //         toast.error(msg, { position: 'top-center', autoClose: 3000, theme: 'light', transition: Bounce });
//   //       }
//   //     });

//   //     window.recaptchaVerifier.render().then(() => {
//   //       setRecaptchaInitialized(true);
//   //       console.log('reCAPTCHA rendered');
//   //     });
//   //   } catch (err) {
//   //     console.error('Failed to setup reCAPTCHA:', err);
//   //   }
//   // }, [t]);

//   useEffect(() => {
//     mountedRef.current = true;
//     // setupRecaptcha();
//     return () => {
//       mountedRef.current = false;
//     };
//   }, []);

//   useEffect(() => {
//     if (timeLeft > 0) {
//       timerRef.current = setInterval(() => {
//         setTimeLeft((prev) => {
//           if (prev <= 1) {
//             clearInterval(timerRef.current);
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//     }
//     return () => clearInterval(timerRef.current);
//   }, [timeLeft]);

//   const formatPhoneNumber = (phoneNumber) => {
//     const cleaned = phoneNumber.replace(/\D/g, '');
//     return cleaned.startsWith('974') ? `+${cleaned}` : `+974${cleaned}`;
//   };

//   const validatePhoneNumber = (number) => /^\+974[3-7]\d{7}$/.test(number);

//   const sendOTP = async (e) => {
//     e.preventDefault();
//     setError('');
//     setIsLoading(true);

//     const formatted = formatPhoneNumber(phone);
//     if (!validatePhoneNumber(formatted)) {
//       const msg = t('mobileval') || 'Please enter a valid mobile number';
//       setError(msg);
//       toast.error(msg, { position: 'top-center', autoClose: 3000, theme: 'light', transition: Bounce });
//       setIsLoading(false);
//       return;
//     }

//     // if (!recaptchaInitialized || !window.recaptchaVerifier) {
//     //   const msg = t('recaptchaerror') || 'reCAPTCHA not ready. Please wait.';
//     //   setError(msg);
//     //   toast.error(msg, { position: 'top-center', autoClose: 3000, theme: 'light', transition: Bounce });
//     //   setIsLoading(false);
//     //   return;
//     // }

//     try {
//       const result = await signInWithPhoneNumber(auth, formatted, undefined);
//       setConfirmationResult(result);
//       setShowOTP(true);
//       setTimeLeft(120);
//       setRetryCount(0);
//       toast.success(t('otpsent') || 'OTP sent successfully', {
//         position: 'top-center',
//         autoClose: 3000,
//         theme: 'light',
//         transition: Bounce,
//       });
//     } catch (err) {
//       console.error('Error sending OTP:', err);
//       const msg = getErrorMessage(err);
//       setError(msg);
//       toast.error(msg, { position: 'top-center', autoClose: 5000, theme: 'light', transition: Bounce });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const verifyOTP = async (e) => {
//     e.preventDefault();
//     setError('');
//     setIsLoading(true);

//     if (!confirmationResult) {
//       setError(t('otperror') || 'No OTP confirmation available');
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const result = await confirmationResult.confirm(otp);
//       setVerificationSuccess(true);
//       toast.success(t('verification_success') || 'Phone verified successfully', {
//         position: 'top-center',
//         autoClose: 3000,
//         theme: 'light',
//         transition: Bounce,
//       });
//       onValidation(phone, result.user);
//     } catch (err) {
//       console.error('OTP verification failed:', err);
//       let msg = t('otperror') || 'Invalid OTP';
//       if (err.code === 'auth/invalid-verification-code') msg = t('invalid_otp') || 'Invalid OTP code';
//       else if (err.code === 'auth/code-expired') msg = t('otp_expired') || 'OTP code expired';
//       setError(msg);
//       toast.error(msg, { position: 'top-center', autoClose: 3000, theme: 'light', transition: Bounce });
//       if (retryCount >= 2) setOtp('');
//       setRetryCount(prev => prev + 1);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const getErrorMessage = (err) => {
//     switch (err.code) {
//       case 'auth/invalid-phone-number': return t('invalidformat') || 'Invalid phone number';
//       case 'auth/too-many-requests': return t('toomanyattempts') || 'Too many attempts, try again later';
//       case 'auth/quota-exceeded': return t('servicedown') || 'Service temporarily unavailable';
//       case 'auth/captcha-check-failed': return t('recaptchaerror') || 'reCAPTCHA failed';
//       case 'auth/invalid-app-credential': return t('config_error') || 'Firebase config error';
//       case 'auth/missing-phone-number': return t('missing_phone') || 'Missing phone number';
//       case 'auth/invalid-verification-code': return t('invalid_otp') || 'Invalid OTP';
//       case 'auth/code-expired': return t('otp_expired') || 'OTP expired';
//       case 'auth/network-request-failed': return t('network_error') || 'Network error';
//       default: return t('failedotp') || 'Failed to send OTP';
//     }
//   };

//   return (
//     <div className="space-y-6 py-10">
//       <h2 className="text-xl font-bold text-[#0a2942]">{t('verifyphone')}</h2>

//       {/* <div id="recaptcha-container" style={{ display: 'none' }}></div> */}

//       {error && (
//         <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
//           {error}
//         </div>
//       )}

//       {/* {!recaptchaInitialized && (
//         <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded-lg text-sm">
//           {t('initializing') || 'Initializing reCAPTCHA...'}
//         </div>
//       )} */}

//       {!showOTP ? (
//         <form onSubmit={sendOTP} className="space-y-4">
//           <div className="relative">
//             <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">+974</span>
//             <input
//               type="tel"
//               value={phone}
//               onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
//               placeholder={t('entermobile') || 'Enter mobile number'}
//               className="w-full p-3 pl-16 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-[#ff8000]"
//               maxLength="8"
//               disabled={isLoading }
//               autoComplete="tel"
//             />
//           </div>
//           <button
//             type="submit"
//             disabled={isLoading || phone.length !== 8 }
//             className="w-full bg-[#ff8000] hover:bg-[#ff9933] text-white font-bold py-4 rounded-full disabled:opacity-50 flex items-center justify-center transition-colors"
//           >
//             {isLoading ? <Loader2 className="w-6 h-6 animate-spin" /> : t('sendotp') || 'Send OTP'}
//           </button>
//         </form>
//       ) : (
//         <form onSubmit={verifyOTP} className="space-y-4">
//           <input
//             type="text"
//             value={otp}
//             onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
//             placeholder={t('enterotp') || 'Enter OTP'}
//             className="w-full p-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-[#ff8000] text-center text-lg"
//             maxLength="6"
//             disabled={isLoading}
//             autoComplete="one-time-code"
//           />
//           {timeLeft > 0 && (
//             <p className="text-sm text-gray-500 text-center">
//               {t('resendotp') || 'Resend OTP in'} {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}
//             </p>
//           )}
//           <div className="space-y-2">
//             <button
//               type="submit"
//               disabled={isLoading || otp.length !== 6}
//               className="w-full bg-[#ff8000] hover:bg-[#ff9933] text-white font-bold py-4 rounded-full disabled:opacity-50 flex items-center justify-center transition-colors"
//             >
//               {isLoading ? <Loader2 className="w-6 h-6 animate-spin" /> : t('verifyotp') || 'Verify OTP'}
//             </button>
//             {timeLeft === 0 && (
//               <button
//                 type="button"
//                 onClick={() => {
//                   setOtp('');
//                   setShowOTP(false);
//                   setConfirmationResult(null);
//                   setError('');
//                 }}
//                 className="w-full border border-[#ff8000] text-[#ff8000] font-bold py-4 rounded-full hover:bg-orange-50 transition-colors"
//                 disabled={isLoading}
//               >
//                 {t('resend_otp') || 'Resend OTP'}
//               </button>
//             )}
//           </div>
//         </form>
//       )}
//     </div>
//   );
// };

// export default MobileValidation;


import React, { useEffect, useState, useRef } from 'react';
import { Bounce, toast } from 'react-toastify';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const MobileValidation = ({ onValidation, mobile = '' }) => {
  const [phone, setPhone] = useState(mobile);
  const [showOTP, setShowOTP] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0); // countdown shown to user
  const autoVerifyRef = useRef(null);
  const countdownRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      // cleanup timers on unmount
      clearTimeout(autoVerifyRef.current);
      clearInterval(countdownRef.current);
    };
  }, []);

  const validatePhoneNumber = (number) => /^\d{8}$/.test(number);

  const startCountdown = (seconds = 5) => {
    setTimeLeft(seconds);

    clearInterval(countdownRef.current);
    countdownRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const sendOTP = (e) => {
    e.preventDefault();
    setError('');

    if (!validatePhoneNumber(phone)) {
      const msg = t('mobileval') || 'Please enter a valid 8-digit mobile number';
      setError(msg);
      toast.error(msg, { position: 'top-center', autoClose: 3000, theme: 'light', transition: Bounce });
      return;
    }

    // simulate sending OTP and auto validation flow
    setIsLoading(true);
    setShowOTP(true);

    // show OTP screen and start countdown for 5 seconds
    startCountdown(5);

    // simulate a short delay for "sending" then auto-verify after 5s
    clearTimeout(autoVerifyRef.current);
    autoVerifyRef.current = setTimeout(() => {
      // simulate verification success
      setIsLoading(false);
      toast.success(t('verification_success') || 'Phone verified successfully (simulated)', {
        position: 'top-center',
        autoClose: 2000,
        theme: 'light',
        transition: Bounce,
      });

      // call provided callback as if verification succeeded
      // passing a small fake user object to match your previous onValidation signature
      onValidation(phone, { autoVerified: true });
    }, 5000);
  };

  return (
    <div className="space-y-6 py-10">
      <h2 className="text-xl font-bold text-[#0a2942]">{t('verifyphone') || 'Verify phone'}</h2>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
          {error}
        </div>
      )}

      {!showOTP ? (
        <form onSubmit={sendOTP} className="space-y-4">
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">+974</span>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
              placeholder={t('entermobile') || 'Enter mobile number'}
              className="w-full p-3 pl-16 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-[#ff8000]"
              maxLength="8"
              disabled={isLoading}
              autoComplete="tel"
            />
          </div>
          <button
            type="submit"
            disabled={isLoading || phone.length !== 8}
            className="w-full bg-[#ff8000] hover:bg-[#ff9933] text-white font-bold py-4 rounded-full disabled:opacity-50 flex items-center justify-center transition-colors"
          >
            {isLoading ? <Loader2 className="w-6 h-6 animate-spin" /> : t('sendotp') || 'Send OTP'}
          </button>
        </form>
      ) : (
        <div className="space-y-4">
          <div>
            {/* OTP input visually present to match flow but disabled since we auto-verify */}
            <input
              type="text"
              value={''}
              placeholder={t('enterotp') || 'Waiting for auto validation...'}
              className="w-full p-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-[#ff8000] text-center text-lg"
              maxLength="6"
              disabled
              autoComplete="one-time-code"
            />
          </div>

          <p className="text-sm text-gray-500 text-center">
            {isLoading ? (
              <>
                <span className="inline-flex items-center gap-2">
                  <Loader2 className="w-4 h-4 animate-spin" />
                  {t('validating') || 'Validating...'}
                </span>
              </>
            ) : (
              t('validated') || 'Validated'
            )}
          </p>

          <p className="text-sm text-gray-500 text-center">
            {t('resendotp') || 'Auto verification in'} {timeLeft}s
          </p>

          <div className="space-y-2">
            <button
              type="button"
              onClick={() => {
                // allow user to cancel and go back to phone entry
                clearTimeout(autoVerifyRef.current);
                clearInterval(countdownRef.current);
                setShowOTP(false);
                setIsLoading(false);
                setTimeLeft(0);
                setError('');
              }}
              className="w-full border border-[#ff8000] text-[#ff8000] font-bold py-4 rounded-full hover:bg-orange-50 transition-colors"
            >
              {t('cancel') || 'Cancel'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileValidation;
